export default __webpack_public_path__ + "static/itemBg26-dc19990e2c36830516390e257ffa4bf8.png";